import DesktopCalendar from '@/containers/Desktop/DesktopCalendar';
import { setShowCalendarVietNam } from '@/slices/calendar/calendarSlice';
import { useAppDispatch } from '@/utils/hook';
import React, { useEffect } from 'react';

// Component
import CalendarFareNewYear from './CalendarFareNewYear';

function Section01(props: any) {
  const {
    selectedDate, dayTetPriceObjs, onSearchFlight, findDayNewYear, isLoading,
  } = props;

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setShowCalendarVietNam({ value: true }));
  }, []);
  return (
    <DesktopCalendar
      isLunarYearMode
      disableChangeMonth
      limit={1}
      isLoading={isLoading}
      isDisableRoundTrip
      type="depart"
      dayPriceObj={dayTetPriceObjs}
      selectedDate={{
        depart: new Date(findDayNewYear?.date),
        return: null,
      }}
      setSelectedDateFunc={onSearchFlight}
    />
  );
}

export default React.memo(Section01);
